import { Contract } from '@ethersproject/contracts'

export async function getInviter(contract: Contract, account: string): Promise<string> {
  return (await contract.inviter(account)).toString()
}
